import React, { Component } from "react"

import clsx from 'clsx'

import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'

import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'

import PropTypes from "prop-types"

import Api from "../../services/api"
import ApiReports from "../../services/apireport";

import moment from "moment"

import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Pagination from '@mui/material/Pagination'
import Divider from '@mui/material/Divider'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"

import Footer from '../../components/footer'
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import MyMaterialTable from "../../components/table";
import RealSimpleAutoComplete from "../../components/auto-complete/autocomplete-with-onclick";
import SimpleAutoCompleteMultiple from "src/components/auto-complete/autocomplete-multiple";
import WebhookExecutionErrorMessage from "../../components/webhook-execution/webhook-execution-error-message";

import { PapiroConsole } from "../../utils/papiroConsole"

import LogoMarca from '../../images/new-logo-cmtech.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class WebhookExecutionReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false

    const { userSession, intl } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",

      showGrid: false,

      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),

      resultList: [],

      allWebhooks: [],
      loadingAllWebhooks: false,
      webhookIds: [],

      allAutomations: [],
      loadingAllAutomations: false,
      automationIds: [],

      allEventTypesCodes: [],
      loadingAllEventTypesCodes: false,
      eventTypeCodes: [],

      deliveryStatus: [],
      allDeliveryStatus: [
        { id: "Pending", name: intl.formatMessage({ id: "webhook.execution.report.filters.pending" }) },
        { id: "Success", name: intl.formatMessage({ id: "webhook.execution.report.filters.success" }) },
        { id: "Failed", name: intl.formatMessage({ id: "webhook.execution.report.filters.failed" }) },
        { id: "Exhausted", name: intl.formatMessage({ id: "webhook.execution.report.filters.exhausted" }) },
        { id: "Skipped", name: intl.formatMessage({ id: "webhook.execution.report.filters.skipped" }) },
        { id: "Processing", name: intl.formatMessage({ id: "webhook.execution.report.filters.processing" }) }
      ],

      sources: [],
      allSources: [
        { id: "WEBHOOK", name: intl.formatMessage({ id: "webhook.execution.report.informations.webhook" }) },
        { id: "AUTOMATION", name: intl.formatMessage({ id: "webhook.execution.report.informations.automation" }) }
      ],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      showHeader: false,

      columns: [],
    }

    this.clear = this.clear.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true })

    this.setState({ loading: false })
  }

  translateSource = (source) => {
    if (!!!source) return "";

    const { intl } = this.props;

    switch (source.toLowerCase()) {
      case "webhook": return intl.formatMessage({ id: "webhook.execution.report.informations.webhook" })
      case "automation": return intl.formatMessage({ id: "webhook.execution.report.informations.automation" })
      default: return source;
    }
  }

  translateStatus = (status) => {
    if(!!!status) return "";

    const { intl } = this.props;

    switch (status.toLowerCase()) {
      case "pending": return intl.formatMessage({ id: "webhook.execution.report.filters.pending" })
      case "success": return intl.formatMessage({ id: "webhook.execution.report.filters.success" })
      case "failed": return intl.formatMessage({ id: "webhook.execution.report.filters.failed" })
      case "exhausted": return intl.formatMessage({ id: "webhook.execution.report.filters.exhausted" })
      case "skipped": return intl.formatMessage({ id: "webhook.execution.report.filters.skipped" })
      case "processing": return intl.formatMessage({ id: "webhook.execution.report.filters.processing" })
      default: return status;
    }

  }

  getAllWebhooks = async () => {
    if (this.state.loadingAllWebhooks || this.state.allWebhooks.length > 0) return;

    const intl = this.props.intl;

    this.setState({ loadingAllWebhooks: true });

    try {
      let url = "/webhooks/active";
      const result = await Api.get(url);
      const response = result.data;

      if (response.success) {
        const data = response.data;

        const formattedData = data.map(item => {
          return {
            ...item
          }
        });

        this.setState({
          loadingAllWebhooks: false,
          allWebhooks: formattedData,
        });
      } else {
        this.setState({
          loadingAllWebhooks: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response.data && response.data.errors
            ? response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
        });
      }
    } catch (err) {
      this.setState({
        loadingAllWebhooks: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors[0]
          : intl.formatMessage({ id: "process.error" }),
      });
    } finally {
      this.setState({ loadingAllWebhooks: false });
    }
  }

  getAllAutomations = async () => {
    if (this.state.loadingAllAutomations || this.state.allAutomations.length > 0) return;

    const intl = this.props.intl;

    this.setState({ loadingAllAutomations: true });

    try {
      let url = "/automation/all-active";
      const result = await Api.get(url);
      const response = result.data;

      if (response.success) {
        const data = response.data;

        const formattedData = data.map(item => {
          return {
            ...item
          }
        });

        this.setState({
          loadingAllAutomations: false,
          allAutomations: formattedData,
        });
      } else {
        this.setState({
          loadingAllAutomations: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response.data && response.data.errors
            ? response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
        });
      }
    } catch (err) {
      this.setState({
        loadingAllAutomations: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors[0]
          : intl.formatMessage({ id: "process.error" }),
      });
    } finally {
      this.setState({ loadingAllAutomations: false });
    }
  }

  getAllEventTypesCodes = async () => {
    if (this.state.loadingAllEventTypesCodes || this.state.allEventTypesCodes.length > 0) return;

    const intl = this.props.intl;

    this.setState({ loadingAllEventTypesCodes: true });

    try {
      let url = "/webhook-event-types/active";
      const result = await Api.get(url);
      const response = result.data;

      if (response.success) {
        const data = response.data;

        const formattedData = data.map(item => {
          const name = !!item.eventname ? `${item.eventname} (${item.eventcode})` : item.eventcode;

          return {
            ...item,
            name
          }
        });

        this.setState({
          loadingAllEventTypesCodes: false,
          allEventTypesCodes: formattedData,
        });
      } else {
        this.setState({
          loadingAllEventTypesCodes: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response.data && response.data.errors
            ? response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
        });
      }
    } catch (err) {
      this.setState({
        loadingAllEventTypesCodes: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors[0]
          : intl.formatMessage({ id: "process.error" }),
      });
    } finally {
      this.setState({ loadingAllEventTypesCodes: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload")
      this.componentDidMount()
  }

  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true })

    PapiroConsole.log(value)
    PapiroConsole.log("value")

    this.setState({ [stateName]: value });

    this.setState({ loading: false })
  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getWebhookExecutionsPaginate(page)
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  getFile = async () => {
    this.setState({ loading: true })

    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');

    let webhookIds = !!this.state.webhookIds.length ? this.state.webhookIds.map(item => item.id).join(",") : null;
    let automationIds = !!this.state.automationIds.length ? this.state.automationIds.map(item => item.id).join(",") : null;
    let eventTypeCodes = !!this.state.eventTypeCodes.length ? this.state.eventTypeCodes.map(item => item.eventcode).join(",") : null;
    let deliveryStatus = !!this.state.deliveryStatus.length ? this.state.deliveryStatus.map(item => item.id).join(",") : null;
    let sources = !!this.state.sources.length ? this.state.sources.map(item => item.id).join(",") : null;

    if (dateStart > dateEnd) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

      return;
    }

    const diffMonths = moment(dateEnd).diff(moment(dateStart), 'months', true);
    if (diffMonths > 6) {
      const { intl } = this.props;

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.date.range.exceeds.six.months" }),
        loading: false
      });

      return;
    }

    let data = {
      DateStart: dateStart,
      DateEnd: dateEnd,
      WebhookIds: webhookIds,
      AutomationIds: automationIds,
      EventTypeCodes: eventTypeCodes,
      DeliveryStatus: deliveryStatus,
      Sources: sources
    }

    let url = `/report/webhookexecution/excel`;

    ApiReports.post(url, data)
      .then((response) => {

        if (response.data.success) {

          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  async clear() {
    this.setState({ loading: true });

    await this.setState({
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      webhookIds: [],
      automationIds: [],
      eventTypeCodes: [],
      deliveryStatus: [],
      sources: [],

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      showGrid: false,

      columns: [],
      resultList: [],
    })

    this.setState({ loading: false });
  }

  getWebhookExecutionsPaginate = async (page = 1) => {
    const { intl } = this.props;

    this.setState({ loading: true });

    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');

    let webhookIds = null;
    let automationIds = null;
    let eventTypeCodes = null;
    let deliveryStatus = null;
    let sources = null;

    if (dateStart > dateEnd) {

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });

      return;
    }

    const diffMonths = moment(dateEnd).diff(moment(dateStart), 'months', true);
    if (diffMonths > 6) {

      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.date.range.exceeds.six.months" }),
        loading: false
      });

      return;
    }

    let url = `/report/webhookexecution/paginate`

    url += `?page=${page}`
    url += `&dateStart=${dateStart}`
    url += `&dateEnd=${dateEnd}`

    if (this.state.webhookIds.length > 0) {
      webhookIds = this.state.webhookIds.map(item => item.id).join(",")
      url += `&webhookIds=${webhookIds}`
    }

    if (this.state.automationIds.length > 0) {
      automationIds = this.state.automationIds.map(item => item.id).join(",")
      url += `&automationIds=${automationIds}`
    }

    if (this.state.eventTypeCodes.length > 0) {
      eventTypeCodes = this.state.eventTypeCodes.map(item => item.eventcode).join(",")
      url += `&eventTypeCodes=${eventTypeCodes}`
    }

    if (this.state.deliveryStatus.length > 0) {
      deliveryStatus = this.state.deliveryStatus.map(item => item.id).join(",")
      url += `&deliveryStatus=${deliveryStatus}`
    }

    if (this.state.sources.length > 0) {
      sources = this.state.sources.map(item => item.id).join(",")
      url += `&sources=${sources}`
    }

    this.setState({ showGrid: true })

    ApiReports.get(url)
      .then(result => {
        if (result.data.success) {
          let count = result.data.count
          this.setState({ count: count })
          this.setPagination(count, page)

          const data = result.data.data;

          const formattedList = data.map(item => {
            return {
              ...item,
              requestsentat: item.requestsentat ? moment(item.requestsentat).format('DD/MM/YYYY HH:mm:ss') : '',
              source: this.translateSource(item.source),
              deliverystatus: this.translateStatus(item.deliverystatus)
            }
          });

          var columns = [
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.id" }), field: 'id' },
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.webhook.name" }), field: 'webhookname' },
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.request.sent" }), field: 'requestsentat' },
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.event.type" }), field: 'eventtypecode' },
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.request.url" }), field: 'requesturl' },
            { title: intl.formatMessage({ id: "webhook.execution.report.informations.source" }), field: 'source' },
            {
              title: intl.formatMessage({ id: "webhook.execution.report.informations.status" }),
              field: 'deliverystatus',
              render: rowData => {
                return <WebhookExecutionErrorMessage deliverystatus={rowData.deliverystatus} errorMessage={rowData.errormessage} intl={intl} />
              },
            }
          ]

          this.setState({ resultList: formattedList, columns, loading: false });
        } else {
          this.setState({
            loading: false, openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
      })
      .catch(err => {
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        })
        Api.kickoff(err)
      })

  }

  handleSubmit = async e => {
    e.preventDefault();

    this.setState({ loading: true });

    await this.getWebhookExecutionsPaginate(1);
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      if (!this.state.showGrid) return null;

      return (
        <React.Fragment>
          <Grid container xs={12}>

            <MyMaterialTable
              title=""
              columns={this.state.columns}
              data={this.state.resultList}
            />
          </Grid>

          <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
            <Grid item xs={12} md={3}>
              <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
            </Grid>
            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
              {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
            </Grid>
          </Grid>
        </React.Fragment>
      )
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            {this.state.showHeader &&
              <Grid container>
                <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{ padding: '2px' }}>
                  <Card >
                    <CardContent>
                      <img src={LogoMarca} style={{ width: "70px" }} /> <span style={{ marginLeft: 25, fontSize: 18 }}>

                        <FormattedMessage id="webhook.execution.report" />
                      </span>
                      <Divider />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            }

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      <FormattedMessage id="webhook.execution.report" />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={4}  >
                      <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <RealSimpleAutoComplete
                        style={{
                          background: "white",
                          fullWidth: true,
                        }}
                        multiple
                        label={intl.formatMessage({ id: "webhook.execution.report.default" })}
                        options={this.state.allWebhooks}
                        stateName="webhookIds"
                        changeSelect={this.changeValues}
                        onFocus={this.getAllWebhooks}
                        loading={this.state.loadingAllWebhooks}
                        selected={this.state.webhookIds}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <RealSimpleAutoComplete
                        style={{
                          background: "white",
                          fullWidth: true,
                        }}
                        multiple
                        label={intl.formatMessage({ id: "webhook.execution.report.automations" })}
                        options={this.state.allAutomations}
                        stateName="automationIds"
                        changeSelect={this.changeValues}
                        onFocus={this.getAllAutomations}
                        loading={this.state.loadingAllAutomations}
                        selected={this.state.automationIds}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <RealSimpleAutoComplete
                        style={{
                          background: "white",
                          fullWidth: true,
                        }}
                        multiple
                        label={intl.formatMessage({ id: "webhook.execution.report.event.types" })}
                        options={this.state.allEventTypesCodes}
                        stateName="eventTypeCodes"
                        changeSelect={this.changeValues}
                        onFocus={this.getAllEventTypesCodes}
                        loading={this.state.loadingAllEventTypesCodes}
                        selected={this.state.eventTypeCodes}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <SimpleAutoCompleteMultiple
                        label={intl.formatMessage({ id: "webhook.execution.report.delivery.status" })}
                        options={this.state.allDeliveryStatus}
                        stateName='deliveryStatus'
                        changeSelect={this.changeValues}
                        selected={this.state.deliveryStatus}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} >
                      <SimpleAutoCompleteMultiple
                        label={intl.formatMessage({ id: "webhook.execution.report.sources" })}
                        options={this.state.allSources}
                        stateName='sources'
                        changeSelect={this.changeValues}
                        selected={this.state.sources}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='secondary' >
                    {<FormattedMessage id="filter" />}
                  </Button>
                </Grid>

                {this.state.showGrid &&
                  <>
                    <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                      <Button
                        fullWidth
                        variant='contained'
                        color='secondary'
                        onClick={this.getFile}
                        disabled={this.state.count === 0}
                      >
                        {<FormattedMessage id="export.plan" />}
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                      <Button
                        type='button'
                        fullWidth
                        variant='outlined'
                        color='secondary'
                        onClick={this.clear}
                      >
                        {<FormattedMessage id="clear" />}
                      </Button>
                    </Grid>
                  </>
                }
              </Grid>
            </form>

            {tableList()}


            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

WebhookExecutionReport.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(WebhookExecutionReport)))
WebhookExecutionReport.contextType = AbilityContext